<template>
  <div>
    <div class="permissManaMain">
      <el-collapse v-model="activeName" accordion @change="change">
        <el-collapse-item
          :title="r.roleName"
          :name="r.id"
          v-for="(r, index) in roles"
          :key="index"
        >
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>可访问资源</span>
            </div>
            <div>
              <el-tree
                show-checkbox
                :data="allMenus"
                :props="defaultProps"
                ref="tree"
                :key="index"
                :default-checked-keys="selectedMenus"
                node-key="id"
                class="tree-border"
                default-expand-all
                empty-text="加载中，请稍候"
              ></el-tree>
              <div class="button-group">
                <el-button size="mini" @click="cancelUpdate"
                  >取消修改</el-button
                >
                <el-button
                  size="mini"
                  type="primary"
                  @click="doUpdate(r.id, index)"
                  >确认修改</el-button
                >
              </div>
            </div>
          </el-card>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import {
  getSelectModuleIdByRoleId,
  getUpdateFunctionByRoleId,
  getAllMenuList,
} from "@/api/plat/PermissMana";
import { getselectMenuListAndChildrenByParam } from "@/api/plat/PlatMenu";
import { getTRoleSelectByPage } from "@/api/plat/PosMana";
export default {
  name: "PermissMana",
  data() {
    return {
      allMenus: [], // 角色列表
      roles: [], // 角色列表
      defaultProps: {
        children: "children",
        label: "name",
      },
      selectedMenus: [], // 放选中的菜单id
      activeName: -1, // -1 关闭所有手缝琴
      // 查询参数
      queryParams: {
        limit: 999,
        page: 1,
        orderBy: "",
        data: {
          createDate: undefined,
          id: undefined,
          isValid: undefined,
          roleCode: undefined,
          roleName: undefined,
          roleRemark: undefined,
          updateDate: undefined,
        },
      },
    };
  },
  mounted() {
    this.initRoles();
  },
  methods: {
    cancelUpdate() {
      this.activeName = -1;
    },
    async doUpdate(rid, index) {
      let tree = this.$refs.tree[index];
      // 获取所有节点 id
      const getAllIds = (nodes) => {
        let ids = [];
        nodes.forEach((node) => {
          ids.push(node.id);
          if (node.children && node.children.length) {
            ids = ids.concat(getAllIds(node.children));
          }
        });
        return ids;
      };
      const allIds = getAllIds(this.allMenus);

      // 获取勾选和半勾选节点 id
      let checkedKeys = tree.getCheckedKeys();
      let halfCheckedKeys = tree.getHalfCheckedKeys();
      let selectedKeys = checkedKeys.concat(halfCheckedKeys);

      // 组装 moduleIdList
      let moduleIdList = allIds.map((id) => ({
        moduleId: id,
        state: selectedKeys.includes(id) ? 1 : 2,
      }));

      let fromData = {
        roleId: rid,
        moduleIdList,
      };
      let resp = await getUpdateFunctionByRoleId(fromData);

      if (resp) {
        this.activeName = -1;
        this.$message.success("修改成功");
      }
    },
    change(rid) {
      //点击手风琴
      if (rid) {
        // 点开 rid 有值，值就是角色id
        // this.initAllMenus();
        this.initSelectedMenus(rid);
      }
    },
    async initSelectedMenus(rid) {
      // 获取菜单树数据
      let resp = await getSelectModuleIdByRoleId(rid);
      if (resp) {
        this.allMenus = resp.data;
        // 只勾选 state === 1 的菜单
        const getCheckedIds = (nodes) => {
          let ids = [];
          nodes.forEach((node) => {
            if (node.children && node.children.length) {
              ids = ids.concat(getCheckedIds(node.children));
            } else if (node.state === 1) {
              ids.push(node.id);
            }
            
          });
          return ids;
        };
        this.selectedMenus = getCheckedIds(this.allMenus);
      }
    },

    async initRoles() {
      //  RoleController.java   (职位)   角色列表getselectMenuListAndChildrenByParam
      let resp = await getTRoleSelectByPage(this.queryParams);
      if (resp) {
        this.roles = resp.data;
      }
    },
  },
};
</script>

<style>
.permissManaTool {
  justify-content: flex-start;
  display: none;
}

.permissManaTool .el-input {
  width: 300px;
  margin-right: 6px;
}

.permissManaMain {
  overflow: auto;
  height: 80vh;
}
.button-group {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
